import { useNavigate } from "react-router-dom";
import { Image } from "../LazyLoad";
import { deleteItem } from "./helpers";
import { CiTrash } from "react-icons/ci";
import IMGLOGO from '../../Assets/img/logoRopa.png';

export const CardFavorite = ({ id, title, image, price, product_id, setDeleteItem }) => {

  const navigate = useNavigate();

  const removeItem = () => {
    //obtener el id del producto
    const data = deleteItem(id);
    console.log(data);
    setDeleteItem(data);
    window.location.reload();
    // const newStore = store.filter((item) => item.id !== id);
    // setStore(newStore);
  };

  const handleViewProduct = () => {
    navigate(`/view-product/${product_id}`);
  }

  return (
    <div className="card shadow-none border border-1 p-0 mb-3" style={{ maxHeight: "120px" }} tabIndex={id}>
      <div className="row ">
        <div
          className="col-4 d-flex justify-content-center align-content-center"
          style={{ height: "110px" }}
          onClick={handleViewProduct}
        >
          <Image
            src={image || IMGLOGO} 
            alt="Producto"  
            style={{ maxWidth: "100%" }}
            className="img-fluid rounded-start"
          />
        </div>
        <div className="col-8">
          <div className="card-body">
            <h5 className="card-title m-0 p-0" style={{ fontSize: "15px" }}>
              {title}
            </h5>
            <p className="card-text m-0 p-0" style={{ fontSize: "13px" }}>
              <small className="text-muted">{price}</small>
            </p>
            <div className="p-0 m-0 d-flex justify-content-around">
              <button className={"btn btn-sm btn-danger"} onClick={removeItem}>
                <CiTrash className="fs-6" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
